(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('historicoRecomendacoes', HistoricoRecomendacoes);

  function HistoricoRecomendacoes() {
    return {
      restrict: 'E',
      controller: 'HistoricoRecomendacoesWrapperCtrl',
      controllerAs: 'recWrap',
      templateUrl: 'views/painel_propriedade/_historico_recomendacoes.html'
    };
  }

}());
